var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUniversalCurrency = function SvgUniversalCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-200v-560h800v560zm120-200h120q17 0 28.5-11.5T360-440v-70q0-17-11.5-28.5T320-550h-60v-30h100v-60H200v150h100v30H200zm240 80h320v-22q0-45-44-71.5T600-440t-116 26.5-44 71.5zm160-160q33 0 56.5-23.5T680-560t-23.5-56.5T600-640t-56.5 23.5T520-560t23.5 56.5T600-480M160-280h640v-400H160zm0 0v-400z"
  })));
};
export default SvgUniversalCurrency;